module.exports = require("ramda/src/is");